import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import VideoCall from "./VideoCall";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:id" element={<VideoCall />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
};

export default App;
